export enum EnvironmentEnum {
    LOCAL = 'local',
    STAGING = 'staging',
    PRODUCTION = 'production'
}